import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    retencionTipoId: 0,
    retencionTipo: null,
    retencionTipoNombre: null,
    retencionRegimenId: 0,
    retencionRegimen: null,
    retencionRegimenNombre: null,
    importe: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_RETENCION_PROVEEDOR'(state) {
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD');
        state.retencionTipoId = 0;
        state.retencionTipo = null;
        state.retencionTipoNombre = null;
        state.retencionRegimenId = 0;
        state.retencionRegimen = null;
        state.retencionRegimenNombre = null;
        state.importe = 0;
    },
    'SET_RETENCION_TIPO'(state, retencionTipo) {
        state.retencionTipo = retencionTipo;
        state.retencionTipoId = retencionTipo ? retencionTipo.id : 0;
        state.retencionTipoNombre = retencionTipo ? retencionTipo.nombre.trim() : null;
    },
    'SET_RETENCION_REGIMEN'(state, retencionRegimen) {
        state.retencionRegimen = retencionRegimen;
        state.retencionRegimenId = retencionRegimen ? retencionRegimen.id : 0;
        state.retencionRegimenNombre = retencionRegimen ? retencionRegimen.nombre.trim() : null;
    },
};

const getters = {
    getField,

    retencionProveedor (state) {
        return {
            fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
            retencionTipoId: parseInt(state.retencionTipoId),
            retencionTipo: state.retencionTipo,
            retencionTipoNombre: state.retencionTipoNombre,
            retencionRegimenId: parseInt(state.retencionRegimenId),
            retencionRegimen: state.retencionRegimen,
            retencionRegimenNombre: state.retencionRegimenNombre,
            importe: parseFloat(state.importe),
        }
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETENCION_PROVEEDOR');
            resolve();
        }, error => {
            reject(error);
        })
    },
    setRetencionTipo: ({commit}, retencionTipo) => {
        commit('SET_RETENCION_TIPO', retencionTipo);
    },
    setRetencionRegimen: ({commit}, retencionRegimen) => {
        commit('SET_RETENCION_REGIMEN', retencionRegimen);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}